import React from "react";
import { useTranslation } from "react-i18next";
import { startOfDay } from "date-fns";
import EAAlert from "../../shared/EAAlert";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import { ClubCart } from "../../../models/ClubCart";

const FIT_PARK_FACILITIES = ["1241", "1243"];
const MAX_SHORTENED_DAYS = 30;

interface IProps {
  facilityIds: string;
  clubCarnetDetails?: ClubCart;
  rulesAccepted: boolean;
  onRulesAcceptedChange: (checked: boolean) => void;
  hasContinuityIssue: boolean;
  continuityAccepted: boolean;
  onContinuityAcceptedChange: (checked: boolean) => void;
}

export const ClubPassNotices: React.FC<IProps> = ({
  facilityIds,
  clubCarnetDetails,
  rulesAccepted,
  onRulesAcceptedChange,
  hasContinuityIssue,
  continuityAccepted,
  onContinuityAcceptedChange,
}) => {
  const { t } = useTranslation();
  const isFitPark = FIT_PARK_FACILITIES.includes(facilityIds);
  const isFirstPurchase = !clubCarnetDetails || clubCarnetDetails.first;
  const isLateRenewal =
    !isFirstPurchase && Boolean(clubCarnetDetails?.from) && new Date(clubCarnetDetails!.from) < startOfDay(new Date());
  const shortenedDays = Math.min(clubCarnetDetails?.daysBetween ?? 0, MAX_SHORTENED_DAYS);

  const renderFitParkAlert = () => {
    if (isFirstPurchase) {
      return (
        <EAAlert
          type="warning"
          compact
          message="Drogi Kliencie, to będzie Twój pierwszy zakup Karty Klubowej Imiennej FitPark Open na 2 miesiące! Prosimy o zapoznanie się z zasadami prolongaty karnetu w przypadku kolejnych zakupów."
        />
      );
    }
    if (isLateRenewal) {
      return (
        <EAAlert
          type="error"
          compact
          message={`Ważność Twojej poprzedniej Karty Klubowej Imiennej FitPark Open na 2 miesiące skończyła się (${clubCarnetDetails?.lastCard_validTo}). Zgodnie z zasadami prolongaty Oferty Specjalnej Twój nowy produkt zostanie skrócony o (${clubCarnetDetails?.daysBetween}) dni.`}
        />
      );
    }
    return (
      <EAAlert
        type="success"
        compact
        message="Dziękujemy za kolejny zakup i przedłużenie ważności Twojej Karty Klubowej Imiennej FitPark Open na 2 miesiące w terminie! Do zobaczenia w klubie FitPark!"
      />
    );
  };

  return (
    <div className="club-pass-notices">
      {isFitPark && renderFitParkAlert()}

      <EACheckbox
        name="clubCartAgreement"
        checked={rulesAccepted}
        onChange={onRulesAcceptedChange}
        label={
          <span>
            {t("akceptuje")}{" "}
            <a href="https://www.parkwodny.pl/fitpark/regulamin/" target="_blank" rel="noreferrer">
              {t("warunki_korzystania")}
            </a>{" "}
            {t("z_karty_klubowej_imiennej_fitpark_open_na_2_miesiace")}.
          </span>
        }
      />

      {hasContinuityIssue && (
        <EACheckbox
          name="continuityAgreement"
          checked={continuityAccepted}
          onChange={onContinuityAcceptedChange}
          label={
            <span>
              W związku z niezachowaniem ciągłości (brak kontynuacji wykupu), zakup kolejnego karnetu spowoduje
              skrócenie daty ważności karnetu o liczbę dni opóźnienia (max. o połowę okresu ważności). Karnet zostanie
              skrócony o {shortenedDays} dni.
            </span>
          }
        />
      )}
    </div>
  );
};

export default ClubPassNotices;
